import classNames from "classnames";
import { styled } from "@linaria/react";
import React from "react";
import { color, fonts, opacityElementDisabled } from "..";

export const RADIO_BUTTON_GAP = "10px";

const Wrapper = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  font: ${fonts.body1};
  gap: ${RADIO_BUTTON_GAP};

  &.disabled {
    opacity: ${opacityElementDisabled};
    cursor: not-allowed;
    input:hover {
      box-shadow: none;
    }
  }
`;

const LabelContent = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${color.carbon800};
`;

const Input = styled.input`
  appearance: none;
  position: relative;
  border: 1px solid;
  border-color: ${color.lightNitrogen500_Main};
  border-radius: 50%;
  width: 16px;
  height: 16px;
  box-shadow: 0 0 0 0 ${color.lightNitrogen500_Main};
  transition: 200ms ease box-shadow;
  flex-grow: 0;
  flex-shrink: 0;
  cursor: inherit;

  &:not(:checked):hover,
  &:not(:checked):focus-visible {
    box-shadow: 0 0 0 2px ${color.lightNitrogen500_Main};
  }

  &::after {
    background: ${color.lightNitrogen500_Main};
    transform: scale(0);
    content: "";
    position: absolute;
    border-radius: inherit;
    inset: 0;
    transition: 200ms ease transform;
    cursor: inherit;
  }

  &:checked::after {
    transform: scale(0.7);
  }
`;

type P = React.InputHTMLAttributes<HTMLInputElement>;

const RadioButton = (
  { className, disabled, children, ...props }: P,
  ref: React.Ref<HTMLInputElement>,
) => (
  <Wrapper className={classNames(className, { disabled })}>
    <Input type="radio" ref={ref} disabled={disabled} {...props} />
    {children && <LabelContent>{children}</LabelContent>}
  </Wrapper>
);

export default React.memo(React.forwardRef(RadioButton));
